<div class="kt-subheader kt-grid__item">
    <div class="kt-subheader__main">
        <ng-container *ngIf="isGuided; else breadCrumb">
            <h3 class="kt-subheader__title cursor-pointer">
                <p-breadcrumb [model]="guidedNavItems"></p-breadcrumb>
            </h3>
        </ng-container>

        <ng-template #breadCrumb>
            <h3 class="kt-subheader__title cursor-pointer" *ngIf="orderGuide && orderGuide.name || category && category.name">
                <p-breadcrumb [model]="navItems" [home]="home"></p-breadcrumb>
            </h3>
        </ng-template>
    </div>
    <div class="kt-subheader__toolbar">
        <div class="kt-subheader__wrapper d-flex align-items-center gap-2">
            <app-three-state-toggle
                *ngIf="selectedORderGuideTemplate != undefined && BasePermissionDefinition.Webshop.OrderGuide.ViewTemplate | permission"
                formControlName="toggleState"
                [currentValue]="toggleState"
                (stateChange)="onStateChange($event)"
            ></app-three-state-toggle>

            <button class="btn btn-primary"
                    [disabled]="isDisabled"
                    (click)="goToBasket()">
                {{ "CurrentOrder" | localize }}
            </button>
        </div>
    </div>
</div>

<div class="kt-content distribution">
    <div class="kt-portlet">
        <div class="kt-portlet__body">
            <app-combine-view
                [hideSearch]="isLegacyUI"
                (onQuickAction)="addToBasket($event)"
                [showAdditionalFilters]="true"
                (loadData)="loadData($event)"></app-combine-view>
        </div>
    </div>
</div>


